import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useFeatureToggles, useClickAndReserveFeatureConfig, ClickAndReserveFeatureConfigEnum } from "@grandvisionhq/state";
import { pushCheckStoreAvailabilityClickEvent } from "../../analytics/analytics/ClickAndReserveEvents.js";
import { ClickAndReserveProvider } from "../../context/context/ClickAndReserveProvider.js";
import ClickAndReserveButtonContainer from "./ClickAndReserveButtonContainer.js";
const ClickAndReserveStoreFinderModal = React.lazy(() => import("./ClickAndReserveModalContainer.js"));
const ClickAndReserveConfigurator = React.lazy(
  () => import("../ClickAndReserveConfigurator/components/ClickAndReserveConfigurator/ClickAndReserveConfigurator.js")
);
const ClickAndReserveStoreFinderWrapper = React.lazy(
  () => import("../ClickAndReserveStoreFinderWrapper/components/ClickAndReserveStoreFinderWrapper/ClickAndReserveStoreFinderWrapper.js")
);
const Fallback = () => /* @__PURE__ */ React.createElement(LoaderScreen, { height: 100 });
const ClickAndReserveContainer = ({
  sku,
  onInvalidClick,
  product
}) => {
  const { featureConfigs, isClickAndReserveEnabled: isFeatureToggleEnabled } = useFeatureToggles();
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [hasInteracted, setHasInteracted] = React.useState(false);
  const clickAndReserveMode = useClickAndReserveFeatureConfig();
  const handleOnButtonOnClick = React.useCallback(() => {
    if (!!onInvalidClick) {
      onInvalidClick();
      return;
    }
    if (clickAndReserveMode) {
      pushCheckStoreAvailabilityClickEvent(clickAndReserveMode);
      setModalOpen(true);
      !hasInteracted && setHasInteracted(true);
    }
  }, [onInvalidClick, clickAndReserveMode, hasInteracted]);
  const handleOnModalClose = React.useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);
  const showClickAndReserveButton = isFeatureToggleEnabled && (featureConfigs?.clickAndReserve ?? "") in ClickAndReserveFeatureConfigEnum && product.activeVariant.isReservable;
  if (!showClickAndReserveButton) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
          .gm-style
            .gm-style-iw-c:has(
              .click-and-reserve-store-finder-item.stores-v2-store-finder-item--map-item.stores-v2-store-finder-item--disabled
            ) {
            background-color: var(--color--shade-lightest);
            padding: 0.75rem !important;
          }

          .gm-style
            .gm-style-iw-d:has(
              .click-and-reserve-store-finder-item.stores-v2-store-finder-item--map-item.stores-v2-store-finder-item--disabled
            ) {
            overflow: hidden !important;
          }
        `), /* @__PURE__ */ React.createElement(ClickAndReserveButtonContainer, { onClick: handleOnButtonOnClick }), hasInteracted && clickAndReserveMode === "stock_only" && /* @__PURE__ */ React.createElement(React.Suspense, { fallback: /* @__PURE__ */ React.createElement(Fallback, null) }, /* @__PURE__ */ React.createElement(ClickAndReserveStoreFinderWrapper, { sku, key: sku }, /* @__PURE__ */ React.createElement(
    ClickAndReserveStoreFinderModal,
    {
      isOpen: isModalOpen,
      onModalClose: handleOnModalClose,
      sku
    }
  ))), hasInteracted && clickAndReserveMode === "reservation" && /* @__PURE__ */ React.createElement(ClickAndReserveProvider, null, /* @__PURE__ */ React.createElement(React.Suspense, { fallback: /* @__PURE__ */ React.createElement(Fallback, null) }, /* @__PURE__ */ React.createElement(ClickAndReserveStoreFinderWrapper, { sku, key: sku }, /* @__PURE__ */ React.createElement(
    ClickAndReserveConfigurator,
    {
      isOpen: isModalOpen,
      onModalClose: handleOnModalClose,
      sku,
      product
    }
  )))));
};
export {
  ClickAndReserveContainer as default
};
//# sourceMappingURL=ClickAndReserveContainer.js.map
